import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

import {
  Box,
  Grid,
} from '@mui/material';

import {
  Footer,
  WhiteSection
} from '../../../components/v2/custom';
import {
  DarkGreenButton,
  Page,
  TextButton,
  Typography
} from '../../../components/v2/styled';

import { Meeting } from '../../../models/Meeting';
import { User } from '../../../models/User';

const { DateTime } = require("luxon");

type Props = {}

export const MeetingAttend: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const { state } = useLocation();

  const lenis = new Lenis({
    // duration: 2,
  });

  const [meeting, setMeeting] = useState<Meeting>(state?.meeting);
  const [user, setUser] = useState<User>(state?.user);
  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [step, setStep] = useState<number>(0);
  const [mailMode, setMailMode] = useState<number>(0);









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      step: number;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        undefined
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      //@ts-ignore
      setError(data.data);
      setShowError(true);
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);

      setShowError(false);
      setError(undefined);

      if (variables.step === 0) { // verification
        if (!!data.custom_result.vennoot_number) {
          setUser({
            ...data.custom_result,
            birth_date: DateTime.fromISO(data.custom_result?.birth_date).toFormat("dd/LL/y")
          });
          setStep(1);
          setTimeout(() => {
            // lenis.scrollTo("top");
            window.scrollTo(0, 0);
          }, 200);
        } else {
          setError(data.custom_result);
          setShowError(true);
        }
      }
      if (variables.step === 100) { // verification
        if (!!data.custom_result.vennoot_number) {
          navigate("/av", {state: {user: {
            ...data.custom_result,
            birth_date: DateTime.fromISO(data.custom_result?.birth_date).toFormat("dd/LL/y")
          }}});
        } else {
          setError(data.custom_result);
          setShowError(true);
        }
      }

      if (!!data.custom_result.user) {
        setUser({
          ...data.custom_result.user,
          birth_date: DateTime.fromISO(data.custom_result.user?.birth_date).toFormat("dd/LL/y")
        });
      }
    },
  });








  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);
  useEffect(() => {
    if (!!state?.user) setUser(state?.user);
    if (!!state?.meeting) setMeeting(state?.meeting);
  }, [state?.user, state?.meeting]);

  return <Page sx={{paddingTop: '100px', backgroundColor: theme.palette.background.default}}>
    
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 600,
        height:'auto'
      }
    }}>
      <Grid container spacing={1} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 4
      }}>
        {/* <Grid item xs={12} sx={{textAlign: 'center', marginBottom: 8}}>
          <Stepper activeStep={subStep > 10 ? (subStep - 10) : subStep} steps={!!isNew ? 9 : 4} />
        </Grid> */}
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Typography variant="h1" sx={{display: 'inline-block',}}>{t("nw.meeting.physical.attendance.title")}</Typography>
        </Grid>
        {(!user || !meeting) && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Typography variant="body1" sx={{display: 'inline-block', color: theme.palette.warning.main}} html altLinks>{t("nw.meeting.error.reload_from_av")}</Typography>
        </Grid>}


        {/* let active = DateTime.fromISO(meeting?.last_day) >= DateTime.now();
        let already_registered = (user?.av_stuff?.type === 'physical' && !!user?.av_stuff?.enabled);
        let already_voted = (user?.av_stuff?.type === 'vote');
        let gave_volmacht = (user?.av_stuff?.type === 'physical' && !!user?.av_stuff?.volmacht); */}

        {!!user && !!meeting && <>
          {!!showError && <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography sx={{color: theme.palette.warning.main}} variant="body1">{t(`nw.meetings.errors.${error}`).replace(/<[^>]*>?/gm, '')}</Typography>
          </Grid>}
          {!showError && <>
            {!(DateTime.fromISO(meeting?.last_day).set({hour: 23, minute: 59, second: 59}) > DateTime.now()) && <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography sx={{color: theme.palette.warning.main}} variant="body1">{t("nw.meetings.notification.error.after_physical_last_day").replace(/<[^>]*>?/gm, '')}</Typography>
            </Grid>}
            {!!(DateTime.fromISO(meeting?.last_day).set({hour: 23, minute: 59, second: 59}) > DateTime.now()) && <>
              {!!(user?.av_stuff?.type === 'vote') && <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant='body1'>{t("nw.meetings.physical.attendance.already_voted").replace(/<[^>]*>?/gm, '')}</Typography>
              </Grid>}
              {!(user?.av_stuff?.type === 'vote') && <>
                {!!(user?.av_stuff?.type === 'physical' && !!user?.av_stuff?.volmacht) && <Grid item xs={12} sx={{textAlign: 'center'}}>
                  <Typography variant='body1'>{t("nw.meetings.physical.attendance.gave_volmacht").replace(/<[^>]*>?/gm, '')}</Typography>
                </Grid>}
                {!(user?.av_stuff?.type === 'physical' && !!user?.av_stuff?.volmacht) && <>
                  {!!(user?.av_stuff?.type === 'physical' && !!user?.av_stuff?.enabled) && <Grid item xs={12} sx={{textAlign: 'center'}}>
                    <Typography variant='body1'>{t("nw.meetings.physical.attendance.already_registered").replace(/<[^>]*>?/gm, '')}</Typography>
                  </Grid>}
                  {!(user?.av_stuff?.type === 'physical' && !!user?.av_stuff?.enabled) && <>
                    <Grid item xs={12}>
                      <Typography variant='body1'>{t("nw.meetings.physical.attendance.intro").replace(/<[^>]*>?/gm, '')}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{textAlign: 'center'}}>
                      <Box sx={{
                        borderRadius: 1,
                        border: '2px solid transparent',
                        borderColor: theme.palette.primary.main,
                        padding: 2,
                        cursor: 'pointer',
                        width: '100%',
                        height: '145px',
                        display: 'inline-block',
                        margin: 1,
                        opacity: (mailMode !== 2 ? 1 : 0.4)
                      }} onClick={() => {setMailMode(1);}}>
                        <Typography variant="h4" sx={{fontWeight: 'bold'}}>{t("nw.meetings.physical.attendance.by_mail.title").replace(/<[^>]*>?/gm, '')}</Typography>
                        <Typography variant="body1" sx={{marginTop: 1, marginBottom: 1}}>{user.email}</Typography>
                        <TextButton
                          id="mail_btn"
                          label={t("nw.general.actions.choose").replace(/<[^>]*>?/gm, '')}
                          onClick={(e) => {
                            setMailMode(1);
                          }} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{textAlign: 'center'}}>
                      <Box sx={{
                        borderRadius: 1,
                        border: '2px solid transparent',
                        borderColor: theme.palette.primary.main,
                        padding: 2,
                        cursor: 'pointer',
                        width: '100%',
                        height: '145px',
                        display: 'inline-block',
                        margin: 1,
                        opacity: (mailMode !== 1 ? 1 : 0.4)
                      }} onClick={() => {setMailMode(2);}}>
                        <Typography variant="h4" sx={{fontWeight: 'bold'}}>{t("nw.meetings.physical.attendance.by_post.title").replace(/<[^>]*>?/gm, '')}</Typography>
                        <Typography variant="body1" sx={{marginTop: 1, marginBottom: 1}}>{user.address}</Typography>
                        <TextButton
                          id="post_btn"
                          label={t("nw.general.actions.choose").replace(/<[^>]*>?/gm, '')}
                          onClick={(e) => {
                            setMailMode(2);
                          }} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'center'}}>
                      <DarkGreenButton
                        id="confirm"
                        disabled={!mailMode}
                        loading={mutationCustomAction.isPending}
                        label={t("nw.meetings.physical.attendance.confirm").replace(/<[^>]*>?/gm, '')}
                        sx={{
                          borderColor: theme.palette.primary.dark,
                          "&:hover": {
                            borderColor: theme.palette.primary.dark,
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                          },
                          "&.Mui-disabled": {
                            color: 'grey',
                          },
                        }}
                        onClick={(e) => {
                          mutationCustomAction.mutate({
                            formData: {
                              object: 'meeting',
                              class_action: 'custom_api_attend',
                              user_id: user?.id,
                              mail_mode: mailMode
                            },
                            step: 100
                          });
                        }} />
                    </Grid>
                  </>}
                </>}
              </>}
            </>}
          </>}
        </>}

        <Grid item xs={12} sx={{textAlign: 'center', marginTop: 4}}>
          <TextButton
            label={t("nw.emission.forgot.cta_back")}
            id="back_btn"
            onClick={() => {
              navigate("/av");
              setTimeout(() => {
                // lenis.scrollTo("top");
                window.scrollTo(0, 0);
              }, 200);
            }}
            sx={{
              marginBottom: 1,
              color: theme.palette.primary.dark,
              textDecoration: 'underline',
              "&:hover": {
                color: theme.palette.primary.light,
                backgroundColor: 'transparent'
              },
              paddingLeft: 0,
              paddingRight: 0
            }}
          />
        </Grid>

      </Grid>
    </WhiteSection>

    <Footer normalPage />
  </Page>;
}

